import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { api } from './client';
import type { ClientOverview, DataEnvelope, PlatformOverview } from './types';

export type PlatformDays = 7 | 30 | 90;

/** Super admin dashboard across every client (platform scope). */
export function usePlatformOverview(days: PlatformDays) {
  return useQuery<PlatformOverview>({
    queryKey: ['platform', 'overview', days],
    queryFn: ({ signal }) =>
      api<DataEnvelope<PlatformOverview>>('/platform/overview', { query: { days }, signal }).then(
        (r) => r.data,
      ),
    placeholderData: keepPreviousData,
    refetchInterval: 60_000,
  });
}

export function useClientOverview(id: string | undefined, days: PlatformDays) {
  return useQuery<ClientOverview>({
    queryKey: ['platform', 'client', id, days],
    queryFn: ({ signal }) =>
      api<DataEnvelope<ClientOverview>>(`/platform/clients/${id}`, { query: { days }, signal }).then(
        (r) => r.data,
      ),
    enabled: !!id,
    placeholderData: keepPreviousData,
  });
}
